import { AbstractBlock, AwardsListBlock as AwardsList, LocationBlock, LogoBlock, MarkdownBlock, PictureBlock, QuoteBlock, TextBlock } from '@components/contentBlock';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  AwardsList,
  LocationBlock,
  AbstractBlock,
  LogoBlock,
  MarkdownBlock,
  PictureBlock,
  QuoteBlock,
  TextBlock,
};
